import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
        <div className="prose max-w-none">
          <p>Welcome to LocalSEO Suite. By using our services, you agree to comply with and be bound by the following terms and conditions:</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
          <p>By accessing or using LocalSEO Suite's services, you agree to these Terms and Conditions and any additional terms and conditions that may apply to specific sections of our website or to products and services available through our website or from LocalSEO Suite.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">2. Description of Service</h2>
          <p>LocalSEO Suite provides local SEO services designed to improve your business's online visibility. We do not guarantee specific rankings or results, as search engine algorithms are subject to change.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">3. User Responsibilities</h2>
          <p>You are responsible for providing accurate and up-to-date information about your business. LocalSEO Suite is not liable for any issues arising from incorrect information provided by the user.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">4. Payment and Refunds</h2>
          <p>Payment is due at the time of service. Refunds are subject to our Refund Policy, which can be found on our website.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">5. Limitation of Liability</h2>
          <p>LocalSEO Suite is not liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to, or use of, the website or services.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-4">6. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Your continued use of our services after any changes indicates your acceptance of the new terms.</p>
          
          <p className="mt-6">By using LocalSEO Suite's services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;